import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import {
  DeserializeVoid,
  _post,
} from '../../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ToggleRouteCheckedControllerRequestService {
  private readonly post: <T>(
    path: string,
    body: null,
    deserialize: (response: any) => T
  ) => Observable<T>;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post('/tours', requestServices);
  }

  public toggleRouteChecked(tourId: number): Promise<void> {
    return this.post(
      `/toggleRouteChecked/${tourId}`,
      null,
      DeserializeVoid
    ).toPromise();
  }

  public setRouteChecked(tourId: number, routeChecked: boolean): Promise<void> {
    return this.post(
      `/setRouteChecked/${tourId}/${routeChecked}`,
      null,
      DeserializeVoid
    ).toPromise();
  }
}
